<div class="modal-container">
  <button
    id="modalRestablecerContrasenia"
    #modalRestablecerContrasenia
    data-bs-toggle="modal"
    data-bs-target="#modalCambioContrasena"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalCambioContrasena"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header modal-header-govco modal-header-alerts-govco d-flex justify-content-between align-items-center">
          <button
            type="button"
            class="btn-close d-block d-md-inline p-3 mt-2 mt-md-0"
            aria-label="Close"
            (click)="restablecerForm()"></button>
        </div>
        <div class="modal-body modal-body-govco">
          <app-form
            [title]="restablecerContraseniaText['titulo']"
            [fields]="fieldsCambioContrasenia"
            [sumbitButtonText]="restablecerContraseniaText['boton']"
            (changeAction)="onChangeForm($event)"
            (submitAction)="onSubmitResetContrasena($event)"></app-form>
        </div>
      </div>
    </div>
  </div>
</div>
